import React from "react";

const UserRight2 = ({ width, height, color }) => (
  <svg
    fill="none"
    viewBox="0 0 20 20"
    width={width || "20"}
    height={height || "20"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color || "#000000"}
      d="M15.8334 7.5L18.3334 5M18.3334 5L15.8334 2.5M18.3334 5L13.3334 5M13.3334 17.5V16.5C13.3334 15.0999 13.3334 14.3998 13.0609 13.865C12.8212 13.3946 12.4388 13.0122 11.9684 12.7725C11.4336 12.5 10.7335 12.5 9.33341 12.5H5.66675C4.26662 12.5 3.56655 12.5 3.03177 12.7725C2.56137 13.0122 2.17892 13.3946 1.93923 13.865C1.66675 14.3998 1.66675 15.0999 1.66675 16.5V17.5M10.4167 6.25C10.4167 7.86083 9.11091 9.16667 7.50008 9.16667C5.88925 9.16667 4.58341 7.86083 4.58341 6.25C4.58341 4.63917 5.88925 3.33333 7.50008 3.33333C9.11091 3.33333 10.4167 4.63917 10.4167 6.25Z"
    />
  </svg>
);

export default UserRight2;
